import React from "react";
import { DragOverlay } from "@dnd-kit/core";
import { Paper, Typography } from "@mui/material";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";

const dropAnimation = {
  duration: 180,
  easing: "cubic-bezier(0.18, 0.67, 0.6, 1.22)",
};

export function SortableDragOverlay({ activeId, items }) {
  const activeItem = items?.find((item) => item.id === activeId);

  return (
    <DragOverlay dropAnimation={dropAnimation}>
      {activeId && activeItem ? (
        <Paper
          elevation={12}
          sx={{
            px: 2,
            py: 1.25,
            cursor: "grabbing",
            display: "flex",
            alignItems: "center",
            gap: 1,
            backgroundColor: "#fff",
            border: "2px solid #00265E",
            borderRadius: 2,
            transform: "rotate(1.5deg) scale(1.03)",
            boxShadow: "0 24px 48px rgba(0, 38, 94, 0.22)",
            whiteSpace: "nowrap",
          }}
        >
          <DragIndicatorIcon sx={{ color: "#00265E", fontSize: 20 }} />
          <Typography sx={{ fontWeight: 600, color: "#00265E", fontSize: 14 }}>
            {activeItem.title || activeItem.name || activeId}
          </Typography>
        </Paper>
      ) : null}
    </DragOverlay>
  );
}
